<template>
  <van-tabbar v-model="active" class="active_tab">
    <van-tabbar-item v-for="(item,index) in tabbars" :key="index" :to="(item.name)">
      <span>{{item.title}}</span>
      <template slot="icon" slot-scope="props">
        <img :src="props.active ? item.active : item.normal">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
  export default {
    name: "tabbar",
    data() {
      return {
        active: 0,
        tabbars: [
          {
            name: "home",
            title: "首页",
            normal: require("@/assets/home.png"),
            active: require("@/assets/home-op.png")
          },
          {
            name: "category",
            title: "商品分类",
            normal: require("@/assets/category.png"),
            active: require("@/assets/category-op.png")
          },
          {
            name: "matter",
            title: "集成电路",
            normal: require("@/assets/goods.png"),
            active: require("@/assets/goods.png")
          },
          {
            name: "cart",
            title: "购物车",
            normal: require("@/assets/cart.png"),
            active: require("@/assets/cart-op.png")
          },
          {
            name: "mine",
            title: "我的",
            normal: require("@/assets/mine.png"),
            active: require("@/assets/mine-op.png")
          }
        ]
      };
    },
    methods: {

    },
    //通过路由跳转判断选中的样式
    created() {
      if (this.$route.name == "home") {
        this.active = 0;
      } else if (this.$route.name == "category") {
        this.active = 1;
      } else if (this.$route.name == "matter") {
        this.active = 2;
      } else if (this.$route.name == "cart") {
        this.active = 3;
      } else if (this.$route.name == "mine") {
        this.active = 4;
      }
    }
  };
</script>

<style scoped>
  .active_tab img {
    width: 22px;
    height: 22px;
  }

  .van-tabbar-item--active {
    color: #e10f02;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tabbar/index.vue